import catalog from '../../shared/legal-catalog.json';
import ui from '../../shared/legal-ui.json';

export type LegalDocument = (typeof catalog.documents)[number];
export const legalCatalog: { ready: boolean; documents: LegalDocument[]; archives: LegalDocument[] } = catalog;
export const legalAgeModel = catalog.ageModel as 'A' | 'B' | null;
export function legalUi(key: keyof typeof ui) {
  return ui[key];
}
export const legalPreview = import.meta.env.DEV || import.meta.env.MODE === 'preview';
export const legalLinks = [
  ['/zasady', 'Regulamin'],
  ['/prywatnosc', 'Polityka prywatności'],
  ['/warunki-dodawania-pytan', 'Warunki dodawania pytań'],
  ['/cookies', 'Cookies i pamięć przeglądarki']
] as const;
export const legalText = {
  previewNotice: 'Prywatny podgląd dokumentów. Dane i ustawienia oznaczone placeholderami wymagają uzupełnienia przed publicznym uruchomieniem.',
  registrationUnavailable: 'Zakładanie nowych kont nie jest jeszcze dostępne. Możesz korzystać z lokalnej nauki bez konta.'
};

export function safeLegalHref(value: string) {
  if (/\[\[|\]\]|[\s\\]/.test(value) || [...value].some(character => character.charCodeAt(0) < 32)) return undefined;
  if (/^https:\/\//i.test(value) || /^mailto:[^@]+@[^@]+\.[^@]+$/i.test(value) || /^\/(?!\/)/.test(value)) return value;
  return undefined;
}
